@if (tag) {
  <div class="result-list"
    >
    <h1 class="result-list__title">Aiheeseen "{{tag.attributes.name}}" liittyvät ohjeet</h1>
    @if (instructions) {
      <div class="result-list__container"
        >
        @for (instruction of instructions; track instruction) {
          <a class="result-item"
            routerLink="{{ instruction.attributes.path.alias }}"
            >
            @if (instruction.categories.icon) {
              <img [src]="instruction.categories.icon.url+token"
                alt="Instruction icon"
                class="result-item__image">
            } @else {
              <mat-icon class="result-item__icon">article</mat-icon>
            }
            <div class="result-item__title">
              {{instruction.attributes.name}}
            </div>
          </a>
        }
      </div>
    }
  </div>
}

